import type { JSX } from "react";
import { ToggleButton } from "./ui";

interface IncludePartnerToggleProps {
  checked: boolean;
  onChange: (value: boolean) => void;
}

/**
 * IncludePartnerToggle - wrapper around ToggleButton for partner inclusion
 */
export function IncludePartnerToggle({ checked, onChange }: IncludePartnerToggleProps): JSX.Element {
  return (
    <ToggleButton
      checked={checked}
      onChange={onChange}
      label="Include Partner"
      description={
        <div className="text-sm text-gray-600 space-y-2">
          <p>
            For free childcare and child benefit, the partner&apos;s income is considered.
          </p>
          <p>
            If you have no partner, or prefer to confirm eligibility yourself, you can leave this section blank.
          </p>
        </div>
      }
    />
  );
}
